<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品管理">
      <template>
        <!-- <el-button size="small" type="primary" @click="synchronizedPriceTag"
          >同步价签</el-button
        > -->
        <template v-if="hasPermission('商品-商品管理-新增')">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="zeroStockTakeDown"
            >零库存下架</el-button
          >
        </template>

        <template v-if="hasPermission('商品-商品管理-新增')">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="newlyAdded"
            >上架新品</el-button
          >
        </template>

        <template v-if="hasPermission('商品-商品管理-编辑')">
          <el-button size="small" type="primary" @click="updatePurchasePrice"
            >更新采购价</el-button
          >
        </template>

        <!-- <template v-if="hasPermission('商品-商品管理-编辑')">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="importExcel"
            >导入Excel</el-button
          >
          <el-upload
            ref="upload"
            class="upload-excel"
            :action="uploadAction"
            name="userfile"
            :headers="headers"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :show-file-list="false"
            :on-change="handleChange"
          >
          </el-upload>
        </template> -->

        <template v-if="hasPermission('商品-商品管理-查看')">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            style="margin-left: 10px"
            @click="exportExcel"
            >导出Excel</el-button
          >
        </template>
        <template v-if="!isTakeoutRole">
          <el-button
            size="small"
            type="primary"
            style="margin-left: 10px"
            @click="doSyncAll"
            >批量同步电子价签</el-button
          >
        </template>
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @ShopIdChange="handleShopIdChange"
    >
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :key="1"
            v-if="!basicListconfig.searchParameters.shop_id"
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            resizable
            border
            :height="basicListconfig.height"
            :show-overflow-tooltip="true"
          >
            <el-table-column width="70" prop="id" label="ID">
              <template #header>
                <el-tooltip effect="dark" content="ID" placement="top-start">
                  <span>ID</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="class_name" label="商品分类">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品分类"
                  placement="top-start"
                >
                  <span>商品分类</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="150" prop="item_number" label="商品编码">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品编码"
                  placement="top-start"
                >
                  <span>商品编码</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              prop="name"
              label="商品名称"
              show-overflow-tooltip
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品名称"
                  placement="top-start"
                >
                  <span>商品名称</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              prop="item_name_tag"
              label="价签名称"
              show-overflow-tooltip
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="价签名称"
                  placement="top-start"
                >
                  <span>价签名称</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="总库存" align="center">
              <el-table-column width="100" prop="item_stock_single" label="散">
                <template #header>
                  <el-tooltip effect="dark" content="散" placement="top-start">
                    <span>散</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="item_stock_package" label="箱">
                <template #header>
                  <el-tooltip effect="dark" content="箱" placement="top-start">
                    <span>箱</span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column width="100" prop="num" label="总" sortable>
                <template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span>总</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    @click="editShopStockNumButton(scope.row)"
                  >
                    {{ scope.row.num }}</el-link
                  >
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="总库货值" align="center">
              <el-table-column width="100" prop="avg_price" label="成本价">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="成本价"
                    placement="top-start"
                  >
                    <span> 成本价</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.avg_price | money }}</template
                >
              </el-table-column>
              <el-table-column width="100" prop="total_price" label="小计">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="小计"
                    placement="top-start"
                  >
                    <span> 小计</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.total_price | money }}</template
                >
              </el-table-column>
            </el-table-column>
            <el-table-column
              width="100"
              prop="item_stock_safe"
              label="安全库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="安全库存"
                  placement="top-start"
                >
                  <span> 安全库存</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              prop="item_stock_target"
              label="目标库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="目标库存"
                  placement="top-start"
                >
                  <span> 目标库存</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="price_web" label="加盟价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="加盟价"
                  placement="top-start"
                >
                  <span> 加盟价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_web | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_instock" label="分销价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="分销价"
                  placement="top-start"
                >
                  <span> 分销价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_instock | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_member" label="权限价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="权限价"
                  placement="top-start"
                >
                  <span> 权限价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_member | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_outstock" label="批发价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="批发价"
                  placement="top-start"
                >
                  <span> 批发价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_outstock | money }}</template
              >
            </el-table-column>
            <el-table-column
              width="100"
              prop="price_distribution"
              label="门店价"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="门店价"
                  placement="top-start"
                >
                  <span> 门店价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_distribution | money }}</template
              ></el-table-column
            >

            <el-table-column width="100" prop="price_new" label="采购价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="采购价"
                  placement="top-start"
                >
                  <span> 采购价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_new | money }}</template
              >
            </el-table-column>
            <el-table-column
              width="200"
              prop="last_buy_time"
              sortable
              label="采购时间"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="采购时间"
                  placement="top-start"
                >
                  <span> 采购时间</span>
                </el-tooltip>
              </template></el-table-column
            >
            <el-table-column
              width="200"
              sortable
              prop="last_sell_time"
              label="销售时间"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="销售时间"
                  placement="top-start"
                >
                  <span> 销售时间</span>
                </el-tooltip>
              </template></el-table-column
            >
            <el-table-column width="150" prop="item_status" label="状态">
              <template #header>
                <el-tooltip effect="dark" content="状态" placement="top-start">
                  <span> 状态</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{
                  scope.row.item_status == 0
                    ? "上架"
                    : scope.row.item_status == 1
                    ? "下架"
                    : "--"
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <template v-if="hasPermission('商品-商品管理-编辑')">
                    <div
                      class="button button_modify"
                      @click="editButton(scope.row, 1)"
                    >
                      <i class="iconfont icon-bianji"></i> 编辑
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="button button_modify"
                      @click="preview(scope.row, 1)"
                    >
                      <i class="iconfont icon-yulanmoban"></i> 查看
                    </div>
                  </template>

                  <template v-if="hasPermission('商品-商品管理-删除')">
                    <div
                      class="button button_revoke"
                      @click="switchingStates(scope.row)"
                    >
                      <i
                        :class="
                          scope.row.item_status == 0
                            ? 'iconfont icon-iconfontzhizuobiaozhunbduan30'
                            : 'iconfont icon-iconfontzhizuobiaozhunbduan31'
                        "
                      ></i
                      >{{ scope.row.item_status == 0 ? "下架" : "上架" }}
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <el-table
            v-else
            :key="2"
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            resizable
            border
            :height="basicListconfig.height"
            @sort-change="sortChange"
          >
            <el-table-column width="100" prop="class_name" label="商品分类">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品分类"
                  placement="top-start"
                >
                  <span>商品分类</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="150" prop="item_number" label="商品编码">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品编码"
                  placement="top-start"
                >
                  <span>商品编码</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              prop="name"
              label="商品名称"
              show-overflow-tooltip
              ><template #header>
                <el-tooltip
                  effect="dark"
                  content="商品名称"
                  placement="top-start"
                >
                  <span>商品名称</span>
                </el-tooltip>
              </template></el-table-column
            >
            <el-table-column
              width="200"
              prop="item_name_tag"
              label="价签名称"
              show-overflow-tooltip
              ><template #header>
                <el-tooltip
                  effect="dark"
                  content="价签名称"
                  placement="top-start"
                >
                  <span>价签名称</span>
                </el-tooltip>
              </template></el-table-column
            >

            <el-table-column label="门店库存" align="center">
              <el-table-column width="100" prop="item_stock_single" label="散"
                ><template #header>
                  <el-tooltip effect="dark" content="散" placement="top-start">
                    <span>散</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="item_stock_package" label="箱"
                ><template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span>箱</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="num" label="总"
                ><template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span>总</span>
                  </el-tooltip>
                </template></el-table-column
              >
            </el-table-column>

            <el-table-column label="门店货值" align="center">
              <el-table-column width="100" prop="avg_price" label="成本价">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="成本价"
                    placement="top-start"
                  >
                    <span>成本价</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.avg_price | money }}</template
                >
              </el-table-column>
              <el-table-column width="100" prop="total_price" label="小计">
                <template #header>
                  <el-tooltip
                    effect="dark"
                    content="小计"
                    placement="top-start"
                  >
                    <span>小计</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.total_price | money }}</template
                >
              </el-table-column>
            </el-table-column>

            <el-table-column
              width="100"
              prop="num"
              label="总库存"
              sortable="custom"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="总库存"
                  placement="top-start"
                >
                  <span>总库存</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div
                  class="button button_modify"
                  @click="editShopStockNumButton(scope.row)"
                >
                  {{ scope.row.total_num }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              prop="item_stock_safe"
              label="安全库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="安全库存"
                  placement="top-start"
                >
                  <span>安全库存</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              prop="item_stock_target"
              label="目标库存"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="目标库存"
                  placement="top-start"
                >
                  <span>目标库存</span>
                </el-tooltip>
              </template>
            </el-table-column>
            />
            <el-table-column width="100" prop="price_web" label="加盟价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="加盟价"
                  placement="top-start"
                >
                  <span> 加盟价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_web | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_instock" label="分销价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="分销价"
                  placement="top-start"
                >
                  <span>分销价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_instock | money }}</template
              >
            </el-table-column>

            <el-table-column width="100" prop="price_outstock" label="批发价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="批发价"
                  placement="top-start"
                >
                  <span>批发价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_outstock | money }}</template
              >
            </el-table-column>
            <el-table-column
              width="100"
              prop="price_distribution"
              label="门店价"
            >
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="门店价"
                  placement="top-start"
                >
                  <span>门店价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_distribution | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_member" label="权限价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="权限价"
                  placement="top-start"
                >
                  <span>权限价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_member | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_web" label="加盟价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="加盟价"
                  placement="top-start"
                >
                  <span>加盟价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_web | money }}</template
              >
            </el-table-column>
            <el-table-column width="100" prop="price_new" label="采购价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="采购价"
                  placement="top-start"
                >
                  <span>采购价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.price_new | money }}</template
              >
            </el-table-column>
            <el-table-column width="180" prop="last_buy_time" label="采购时间">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="采购时间"
                  placement="top-start"
                >
                  <span>采购时间</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="180" prop="last_sell_time" label="销售时间">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="销售时间"
                  placement="top-start"
                >
                  <span>销售时间</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="180" prop="position" label="货架号">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="货架号"
                  placement="top-start"
                >
                  <span>货架号</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column width="150" prop="item_status" label="状态">
              <template #header>
                <el-tooltip effect="dark" content="状态" placement="top-start">
                  <span> 状态</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{
                  scope.row.item_status == 0
                    ? "上架"
                    : scope.row.item_status == 1
                    ? "下架"
                    : "--"
                }}
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="180"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <template v-if="hasPermission('商品-商品管理-编辑')">
                    <div style="display: flex; align-items: center">
                      <div
                        class="button button_modify"
                        @click="editButton(scope.row, 2)"
                      >
                        <i class="iconfont icon-bianji"></i> 编辑
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="button button_modify"
                      @click="preview(scope.row, 2)"
                    >
                      <i class="iconfont icon-yulanmoban"></i> 查看
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_footer" v-if="basicListconfig.isPage">
          <p class="table_footer_total">共{{ basicListconfig.total }}项数据</p>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 500]"
            :current-page.sync="basicListconfig.searchParameters.page"
            :page-size="basicListconfig.searchParameters.limit"
            layout="sizes,prev, pager, next"
            :total="basicListconfig.total"
          >
          </el-pagination>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <!-- 更新采购价 -->
    <updateProcurement
      :updatePriceObj="updatePriceObj"
      @close="closeupdate"
    ></updateProcurement>
    <!-- 上架商品 -->
    <listingProducts
      @close="cancelListing"
      :listingProducts="listingProductsObj"
    ></listingProducts>
    <!-- 显示库存明细 -->
    <shopStockNum
      v-if="shopStockNumDialogParams.visible"
      :dialogParams="shopStockNumDialogParams"
      @close="closeThePopUpWindowShopStockNum"
    ></shopStockNum>
    <!-- 查看详情 -->
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      width="900px"
    ></previewComponents>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import { mapGetters } from "vuex";
import {
  stockItemGetlist,
  stockItemDel,
  stockItemActive,
  stockItemLock,
  shopStockItemGetlist,
  stockItemGetOne,
  shopStockItemGetOne,
  syncAll,
  stockItemZeroStockLock,
} from "@/api/product";
import { itemClassGetList, getshoplist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "merchantProductManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    updateProcurement: () => import("./updatePurchasePrice.vue"),
    listingProducts: () => import("./listingProducts.vue"),
    shopStockNum: () => import("../storeProductManagement/shopStockNum.vue"),
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      compId: null,
      shopId: null,
      userId: null,
      roleId: null,
      comp_level: 0,
      // 导入文件
      headers: "",
      fileList: [], // 用于存储已选择的文件列表
      host: "", // 后端服务地址
      uploadAction: "",
      downloadUrl: "",

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      shopStockNumDialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 批量更新
      listingProductsObj: {
        visible: false,
        key: new Date().getTime(),
      },
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            key: "shop_id",
            options: [],
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            key: "class_id",
            options: [],
          },

          {
            label: "产品类型",
            key: "type_id",
            type: "select",
            options: [
              {
                label: "全部",
                value: 1,
              },
              {
                label: "自营",
                value: 2,
              },
              {
                label: "联营",
                value: 3,
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "上架",
                value: 1,
              },
              {
                label: "下架",
                value: 2,
              },
            ],
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          // {
          //   label: "采购时间",
          //   type: "daterange",
          //   key: "buy_time",
          // },
          // {
          //   label: "销售时间",
          //   type: "daterange",
          //   key: "sell_time",
          // },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      updatePriceObj: {
        key: new Date().getTime(),
        visible: false,
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;
    this.comp_level = this.$store.getters.userInfo.comp_level;
    this.headers = {
      "x-token": getSession(),
    };

    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.host = "http://47.100.124.64";
        break;
      // 开发同源
      case "dev":
        this.host = "https://erp.zuizhenshi.cn";
        break;
      // 开发跨域
      case "local":
        this.host = "https://erp.zuizhenshi.cn";
        break;
    }
    // this.host = 'http://106.14.197.16:8080'
    this.uploadAction = this.host + "/admin/shop_stock_item/importExcel";
    this.downloadUrl = this.host + "/admin/shop_stock_item/exportExcel";

    this.obtainDataSource();
    if (JSON.parse(getRoles()).role_id == 4) {
      this.searchEvent({ shop_id: JSON.parse(getRoles()).shop_id });
    } else {
      this.getlist();
    }
  },
  computed: {
    ...mapGetters(["hasPermission", "isTakeoutRole"]),
  },
  methods: {

      // 零库存商品下架
      zeroStockTakeDown() {
        this.$confirm("是否确认将所有零库存商品下架？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          stockItemZeroStockLock({
            comp_id: JSON.parse(getRoles()).comp_id,
            shop_id: this.basicListconfig.searchParameters.shop_id,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          });
        });
      },

    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      if (this.basicListconfig.searchParameters.shop_id) {
        this.viewStoreProducts();
      } else {
        this.getlist();
      }
    },
    synchronizedPriceTag() {},
    handleShopIdChange(val) {
      this.basicListconfig.searchParameters.shop_id = val;
      this.searchEvent({ shop_id: val });
    },
    // 上传Excel
    importExcel() {
      this.$refs.upload.$el.querySelector('input[type="file"]').click();
    },
    // 上传前的处理
    beforeUpload(file) {
      // 检查文件类型
      const isExcel =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        this.$message.error("只能上传Excel文件");
      }
      return isExcel;
    },
    // 文件上传成功的处理
    handleSuccess(response, file) {
      if (response.code == 1) {
        this.$message.success("文件上传成功");
        this.getlist();
      } else {
        this.$message.error("文件上传失败 " + response.msg);
      }
    },
    // 文件选择改变时的处理
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };
      let shopId = this.basicListconfig.searchParameters.shop_id;
      if (!shopId) {
        this.$message.error("请先选中店面");
        return;
      }
      let url =
        this.downloadUrl + "?comp_id=" + this.compId + "&shop_id=" + shopId;

      this.basicListconfig.searchParameters.with_joinshop = 1;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      let export_params = this.basicListconfig.searchParameters;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        params: export_params,
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-门店商品-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },

    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    // 查看事件
    preview(row, num) {
      this.previewParams.code = row.name;
      if (num == 1) {
        stockItemGetOne({
          comp_id: JSON.parse(getRoles()).comp_id,
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            let order_info = res.data[0];
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "商品名称",
                    value: order_info.name,
                  },
                  {
                    label: "类型",
                    value: order_info.class_name,
                  },
                  {
                    label: "父类型",
                    value: order_info.class_pname,
                  },
                  {
                    label: "价签名称",
                    value: order_info.item_name_tag,
                  },
                  {
                    label: "条码",
                    value: order_info.item_number,
                  },
                  {
                    label: "内包装虚拟码",
                    value: order_info.inner_virtual_code,
                  },
                  {
                    label: "外包装虚拟码",
                    value: order_info.outer_virtual_code,
                  },
                  {
                    label: "安全库存",
                    value: order_info.item_stock_safe,
                  },
                  {
                    label: "目标库存",
                    value: order_info.item_stock_target,
                  },
                  {
                    label: "内包装码",
                    value: order_info.inside_number,
                  },
                  {
                    label: "外包装码",
                    value: order_info.outside_number,
                  },
                  {
                    label: "单位",
                    value: order_info.type_spec,
                  },
                  {
                    label: "库存数量",
                    value: order_info.num,
                  },
                  {
                    label: "件内数量",
                    value: order_info.in_package_num,
                  },
                  {
                    label: "件数量",
                    value: order_info.item_stock_package,
                  },
                  {
                    label: "散数量",
                    value: order_info.item_stock_single,
                  },
                  {
                    label: "有效期（月）",
                    value: order_info.keep_month,
                  },
                  {
                    label: "有效期（日）",
                    value: order_info.keep_day,
                  },
                  {
                    label: "最新采购价",
                    value: order_info.price_new,
                  },
                  {
                    label: "分销价",
                    value: order_info.price_instock,
                  },
                  {
                    label: "批发价",
                    value: order_info.price_outstock,
                  },
                  {
                    label: "门店价",
                    value: order_info.price_distribution,
                  },
                  {
                    label: "权限价",
                    value: order_info.price_member,
                  },
                  {
                    label: "加盟价",
                    value: order_info.price_web,
                  },
                  {
                    label: "最高价",
                    value: order_info.max_price,
                  },
                  {
                    label: "最低价",
                    value: order_info.min_price,
                  },
                  {
                    label: "成本价",
                    value: order_info.avg_price,
                  },
                  {
                    label: "是否可散补",
                    value: order_info.is_can_singleAdd == 1 ? "是" : "否",
                  },
                  {
                    label: "商品状态",
                    value: order_info.item_status == 0 ? "上架" : "下架",
                  },
                  {
                    label: "周转天数",
                    value: Number(order_info.item_type),
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else {
        shopStockItemGetOne({
          comp_id: JSON.parse(getRoles()).comp_id,
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            let order_info = res.data[0];
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "商品名称",
                    value: order_info.name,
                  },
                  {
                    label: "类型",
                    value: order_info.class_name,
                  },
                  {
                    label: "父类型",
                    value: order_info.class_pname,
                  },
                  {
                    label: "价签名称",
                    value: order_info.item_name_tag,
                  },
                  {
                    label: "条码",
                    value: order_info.item_number,
                  },
                  {
                    label: "内包装虚拟码",
                    value: order_info.inner_virtual_code,
                  },
                  {
                    label: "外包装虚拟码",
                    value: order_info.outer_virtual_code,
                  },
                  {
                    label: "安全库存",
                    value: order_info.item_stock_safe,
                  },
                  {
                    label: "目标库存",
                    value: order_info.item_stock_target,
                  },
                  {
                    label: "内包装码",
                    value: order_info.inside_number,
                  },
                  {
                    label: "外包装码",
                    value: order_info.outside_number,
                  },
                  {
                    label: "单位",
                    value: order_info.type_spec,
                  },
                  {
                    label: "库存数量",
                    value: order_info.num,
                  },
                  {
                    label: "件内数量",
                    value: order_info.in_package_num,
                  },
                  {
                    label: "件数量",
                    value: order_info.item_stock_package,
                  },
                  {
                    label: "散数量",
                    value: order_info.item_stock_single,
                  },
                  {
                    label: "有效期（月）",
                    value: order_info.keep_month,
                  },
                  {
                    label: "有效期（日）",
                    value: order_info.keep_day,
                  },
                  {
                    label: "最新采购价",
                    value: order_info.price_new,
                  },
                  {
                    label: "分销价",
                    value: order_info.price_instock,
                  },
                  {
                    label: "批发价",
                    value: order_info.price_outstock,
                  },
                  {
                    label: "门店价",
                    value: order_info.price_distribution,
                  },
                  {
                    label: "权限价",
                    value: order_info.price_member,
                  },
                  {
                    label: "加盟价",
                    value: order_info.price_web,
                  },
                  {
                    label: "最高价",
                    value: order_info.max_price,
                  },
                  {
                    label: "最低价",
                    value: order_info.min_price,
                  },
                  {
                    label: "成本价",
                    value: order_info.avg_price,
                  },
                  {
                    label: "是否可散补",
                    value: order_info.is_can_singleAdd == 1 ? "是" : "否",
                  },
                  {
                    label: "商品状态",
                    value: order_info.item_status == 0 ? "上架" : "下架",
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
    },
    // 关闭弹窗
    closeThePopUpWindowShopStockNum() {
      this.shopStockNumDialogParams.visible = false;
      this.shopStockNumDialogParams.key = new Date().getTime();
    },
    // 编辑弹窗
    editShopStockNumButton(row) {
      this.shopStockNumDialogParams.key = new Date().getTime();
      this.shopStockNumDialogParams.visible = true;
      this.shopStockNumDialogParams.id = row.item_id;
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    updatePurchasePrice() {
      this.updatePriceObj.key = new Date().getTime();
      this.updatePriceObj.visible = true;
    },
    closeupdate() {
      this.updatePriceObj.key = new Date().getTime();
      this.updatePriceObj.visible = false;
    },
    switchingStates(row) {
      if (row.item_status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        stockItemLock({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认上架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        stockItemActive({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        stockItemDel({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow(data) {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      if (data == 1) {
        this.getlist();
      } else {
        this.searchEvent({
          shop_id: this.basicListconfig.searchParameters.shop_id,
        });
      }
    },
    // 编辑弹窗
    editButton(row, num) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.num = num;
    },
    // 新增事件
    newlyAdded() {
      this.listingProductsObj.key = new Date().getTime();
      this.listingProductsObj.visible = true;
    },
    cancelListing() {
      this.listingProductsObj.key = new Date().getTime();
      this.listingProductsObj.visible = false;
      this.getlist();
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        if (this.basicListconfig.searchParameters.shop_id) {
          this.viewStoreProducts();
        } else {
          this.getlist();
        }
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key]) && key == "sell_time") {
            this.basicListconfig.searchParameters.last_sell_begin_time =
              data[key][0];
            this.basicListconfig.searchParameters.last_sell_end_time =
              data[key][1];
          } else if (Array.isArray(data[key]) && key == "buy_time") {
            this.basicListconfig.searchParameters.last_buy_begin_time =
              data[key][0];
            this.basicListconfig.searchParameters.last_buy_end_time =
              data[key][1];
          } else {
            delete this.basicListconfig.searchParameters.buy_time;
            delete this.basicListconfig.searchParameters.sell_time;
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        if (this.basicListconfig.searchParameters.shop_id) {
          this.viewStoreProducts();
        } else {
          this.getlist();
        }
      }
    },
    viewStoreProducts() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      shopStockItemGetlist(this.basicListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.basicListconfig.data = res.data.map((item) => {
              if (
                item.last_buy_time.substring(0, 4) == "0000" ||
                item.last_buy_time.substring(0, 4) == "1970"
              ) {
                item.last_buy_time = "-";
              }
              if (
                item.last_sell_time.substring(0, 4) == "0000" ||
                item.last_sell_time.substring(0, 4) == "1970"
              ) {
                item.last_sell_time = "-";
              }
              item.name = item.name + "(1*" + item.in_package_num + ")";
              return item;
            });

            this.basicListconfig.total = res.count;
          } else {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.with_joinshop = 1;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      stockItemGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            if (
              item.last_buy_time.substring(0, 4) == "0000" ||
              item.last_buy_time.substring(0, 4) == "1970"
            ) {
              item.last_buy_time = "-";
            }
            if (
              item.last_sell_time.substring(0, 4) == "0000" ||
              item.last_sell_time.substring(0, 4) == "1970"
            ) {
              item.last_sell_time = "-";
            }
            return item;
          });
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },

    // 同步电子价签
    doSyncAll() {
      this.$confirm(
        "您确定要进行电子价签批量同步吗？此操作将在后台执行，不可撤销。您可继续其他操作。",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.basicListconfig.loading = true;
        syncAll().then((res) => {
          if (res.code == 1) {
            this.$message.success("批量同步结果：" + res.msg);
            this.basicListconfig.loading = false;
          } else {
            this.$message.error("批量同步结果：" + res.msg);
            this.basicListconfig.loading = false;
          }
        });
      });
    },

    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/merchantProductManagement/index.vue